import { render } from "./CreateProductPage.vue?vue&type=template&id=4c38942c&ts=true"
import script from "./CreateProductPage.vue?vue&type=script&lang=ts"
export * from "./CreateProductPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__